import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatToolbar } from '@angular/material/toolbar';
import { Router, RouterOutlet } from '@angular/router';
import { MsalModule } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { AuthService } from './shared/services/auth.service';
import { ShipmentsApiService } from './shared/services/shipments-api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    MsalModule,
    RouterOutlet,
    MatIconButton,
    MatIconModule,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatToolbar,
    MatProgressBar,
    MatDivider
  ]
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly apiService = inject(ShipmentsApiService);

  readonly prodEnv: boolean = environment.production;
  readonly account = computed(() => this.authService.accountInfo());
  readonly isAuthenticated = computed(() => this.authService.isAuthenticated());
  readonly isLoading = computed(() => this.apiService.isLoading());
  readonly title = signal<string|null>(null);

  async ngOnInit(): Promise<void> {
    await this.authService.initialize();
  }

  logout(): void {
    this.authService.logout();
  }

  switchAccount(): void {
    this.authService.switchAccount();
  }

  onNavBackClick(): void {
    this.router.navigateByUrl('..');
  }

  onRouteActivated(activatedComponent: any): void {
    if ('title' in activatedComponent) {
      this.title.set(activatedComponent.title());
    } else {
      this.title.set(null);
    }
  }
}
